var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 6.28C2.02 6.28 0.610001 4.87 0.610001 3.14C0.610001 1.41 2.02 0 3.75 0C5.48 0 6.89 1.41 6.89 3.14C6.89 4.87 5.48 6.28 3.75 6.28ZM3.75 1.5C2.85 1.5 2.11 2.24 2.11 3.14C2.11 4.04 2.85 4.78 3.75 4.78C4.65 4.78 5.39 4.04 5.39 3.14C5.39 2.24 4.65 1.5 3.75 1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.01C7.55 9.01 6.37 7.83 6.37 6.38C6.37 4.93 7.55 3.75 9 3.75C10.45 3.75 11.63 4.93 11.63 6.38C11.63 7.83 10.45 9.01 9 9.01ZM9 5.25C8.38 5.25 7.87 5.76 7.87 6.38C7.87 7 8.38 7.51 9 7.51C9.62 7.51 10.13 7 10.13 6.38C10.13 5.76 9.62 5.25 9 5.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.11 3.14C11.11 4.87 12.52 6.28 14.25 6.28C15.98 6.28 17.39 4.87 17.39 3.14C17.39 1.41 15.98 0 14.25 0C12.52 0 11.11 1.41 11.11 3.14ZM12.61 3.14C12.61 2.24 13.35 1.5 14.25 1.5C15.15 1.5 15.89 2.24 15.89 3.14C15.89 4.04 15.15 4.78 14.25 4.78C13.35 4.78 12.61 4.04 12.61 3.14Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2529 18H17.25C17.66 18 18 17.66 18 17.25V10.74C18 8.67 16.32 6.99 14.25 6.99C12.4876 6.99 11.0079 8.20782 10.607 9.84731C10.1511 9.54141 9.60453 9.37 9 9.37C8.39547 9.37 7.84889 9.54141 7.39295 9.84731C6.99212 8.20782 5.51242 6.99 3.75 6.99C1.68 6.99 0 8.67 0 10.74V17.25C0 17.66 0.34 18 0.75 18H6.74709L6.75 18L6.75291 18H11.2471L11.25 18L11.2529 18ZM12 16.5H16.5V10.74C16.5 9.5 15.49 8.49 14.25 8.49C13.01 8.49 12 9.5 12 10.74V16.5ZM10.5 16.5V12.75C10.5 11.61 9.91 10.87 9 10.87C8.09 10.87 7.5 11.61 7.5 12.75V16.5H10.5ZM6 16.5V10.74C6 9.5 4.99 8.49 3.75 8.49C2.51 8.49 1.5 9.5 1.5 10.74V16.5H6Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.5e69a16dd25f67a77ac522cf7dc2d2e0.svg";
export { ForwardRef as ReactComponent };